import Axios from '@/assets/js/AxiosPlugin'
// 商品列表
export const goodsList = params => {
  return Axios.post('/api/Admin/Points/goodsList', params)
}
// 商品详情
export const goodsInfoApi = params => {
  return Axios.post('/api/Admin/Points/goodsInfo', params)
}
// 商品增加
export const goodsAdd = params => {
  return Axios.post('/api/Admin/Points/goodsAdd', params)
}
// 商品编辑
export const goodsEdit = params => {
  return Axios.post('/api/Admin/Points/goodsEdit', params)
}
// 商品删除
export const goodsDelete = params => {
  return Axios.post('/api/Admin/Points/goodsDelete', params)
}
// 上传图片
export const imgUpload = params => {
  return Axios.post('/api/Admin/Points/imgUpload', params)
}



// WEBPACK FOOTER //
// ./src/views/webpc/CreditMall/GoodsApp/apis/index.js